<template>
  <div class="c-images">
    <ul class="img-list">
      <li class="img-list__item" v-for="(img, i) of images" :key="i">
        <img class="img-list__item__img" :src="img" />
      </li>
    </ul>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ImageSameHeight',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
<style lang="scss" scoped>

.c-images {
  margin: 20px 0;
}
.img-list {
  width: 100%;
  margin: 0 -8px;

  &__item {
    width: auto;
    margin: 0 8px;

    & + & {
      margin-top: 20px;
    }
    &__img {
      width: 100%;
    }
  }
}
@media screen and (min-width: $tablet) {
  .img-list {
    @include flex();
    height: 255px;
    &__item {

        height: 100%;
        &__img {
        width: auto;
        height: 100%;
     }
      & + & {
        margin-top: 0px;
      }
    }
  }
}
</style>
